import {
  Anchor,
  Badge,
  Box,
  Button,
  CopyButton,
  Flex,
  Grid,
  Group,
  LoadingOverlay,
  Select,
  TextInput,
  Tooltip,
} from "@mantine/core";
import React, { useEffect, useState } from "react";

import { useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { IconSearch, IconX } from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_PaginationState,
  MRT_RowSelectionState,
  useMantineReactTable,
} from "mantine-react-table";
import { useNavigate } from "react-router-dom";
import { styleTableMantine } from "../../../../_base/_const/_constVar";
import { NotificationExtension } from "../../../../_base/extension/NotificationExtension";
import Repository from "../../../../_base/helper/HttpHelper";
import OpenProductTab from "../../../../components/ProductTabs";
import { _localization } from "../../../../config/location";
import { API_ROUTE } from "../../../../const/apiRoute";
import { MessageResponse } from "../../../../model/MessageResponse";
import { useProductCreateStore } from "../../../../store/useProductCreateStore";

const ItemComboSet = ({ id }: any) => {
  const navigate = useNavigate();
  const dataItemBase = useProductCreateStore((state) => state.dataItemBase);
  const [datas, setDatas] = useState<any[]>([]);
  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "setName",
        header: "Tên Combo Set",

        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
        size: 500,
        enableColumnResizing: false,
      },
      {
        id: "action",
        header: "Thao tác",
        Cell: ({ row }) => {
          const online = row.original;
          if (online.isSelect === true) {
            return (
              <Anchor
                component="button"
                disabled
                style={{ color: "#aaa", cursor: "not-allowed" }}
              >
                Đã chọn
              </Anchor>
            );
          } else if (online.isSelect === false) {
            return (
              <Anchor
                component="button"
                onClick={() => AddItemComboSet(online.id)}
              >
                Chọn set này
              </Anchor>
            );
          }
        },
        size: 100,
        enableColumnActions: false,
        enableSorting: false,
      },
    ],
    [datas]
  );
  const [height, setHeight] = useState(0);
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [isError, setIsError] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });
  const [selectIds, setSelectIds] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [total, setTotal] = useState(0);
  const [rowCount, setRowCount] = useState(0);
  const [visible, { toggle, close, open }] = useDisclosure(false);
  type SearchCriteria = {
    keySearch?: string;
  };
  const entity = {
    id: 0,
    groupId: 0,
    comboSetId: 0,
    itemId: id,
    discoutValue: 0,
    discoutType: 1,
    isFirstRow: "",
    isFree: "",
    isHot: "",
    isSelect: null,
    creationDate: null,
    createdBy: null,
    lastUpdateDate: null,
    lastUpdatedBy: null,
  };
  const form = useForm<any>({
    mode: "uncontrolled",
    initialValues: {
      ...entity,
    },
  });
  useEffect(() => {
    const valuesList = Object.keys(rowSelection);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
    else {
      const valuesList = Object.keys(rowSelection);
      setSelectIds(valuesList);
    }
  }, [rowSelection]);

  const fetchDataComboSet = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);
    const search = form.getValues();
    const repository = new Repository(process.env.REACT_APP_Demo_APP_API_URL);
    try {
      let urlSearch = `${API_ROUTE.GET_LIST_COMBO_SET}?Skip=${pagination?.pageIndex}&Take=${pagination.pageSize}`;
      if (search.keySearch) {
        urlSearch += `&KeySearch=${search.keySearch.trim().toLowerCase()}`;
      }
      if (search.itemId) {
        urlSearch += `&ItemId=${search.itemId}`;
      }
      if (search.isSelect) {
        urlSearch += `&IsSelect=${search.isSelect}`;
      }
      let callapi = await repository.get<MessageResponse<any[]>>(urlSearch);
      if (callapi && callapi.success) {
        setDatas(callapi?.data ?? []);
        setRowCount(callapi?.totalCount ?? 0);
        setTotal(callapi?.totalCount ?? 0);
        setSelectIds([]);
        table.resetRowSelection();
      } else {
        setDatas([]);
        setRowCount(0);
        setIsLoading(false);
      }
      return callapi?.data;
    } catch (error: any) {
      setDatas([]);
      setIsError(true);
      return null;
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      await fetchDataComboSet();
    };
    fetchData();
  }, [pagination.pageIndex, pagination.pageSize]);
  const AddItemComboSet = async (data: any) => {
    open();

    const apiUrl = `/TblCombosetProd/create?combosetId=${data}`;
    const repository = new Repository(process.env.REACT_APP_Demo_APP_API_URL);
    const dataApi = await repository.post<MessageResponse<any>>(apiUrl, [
      {
        ...form.getValues(),
        comboSetId: data,
        isSelect: true,
      },
    ]);
    if (dataApi?.success) {
      NotificationExtension.Success("Thêm mới thành công");
      fetchDataComboSet();
    }
    close();
  };
  const table = useMantineReactTable({
    columns,
    data: datas,
    rowCount,
    // enableColumnResizing: true,
    enableColumnFilters: true,
    enableSorting: true,
    enableColumnActions: true,
    enableTopToolbar: false,
    enablePagination: true,
    localization: _localization,
    state: {
      // columnFilters,
      // globalFilter,
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading,
      rowSelection,
    },
    enableStickyFooter: true,
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    onPaginationChange: setPagination,
    positionToolbarAlertBanner: "bottom",
    initialState: {
      showColumnFilters: false,
      // columnPinning: {
      //   left: ["STT"],
      //   right: ["status", "action"],
      // },
      columnVisibility: { id: false },
      density: "xs",
    },
    mantineTopToolbarProps: {
      style: {
        display: "none",
      },
    },
    getRowId: (row) => row.id,
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    mantineTableBodyCellProps: ({ row }) => ({
      style: styleTableMantine,
    }),
    mantineToolbarAlertBannerProps: false
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,

    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      radius: "xl",
      size: "lg",
      rowsPerPageOptions: ["20", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    mantineTableBodyRowProps: ({ row }) => ({
      onClick: row.getToggleSelectedHandler(),
      sx: { cursor: "pointer" },
    }),
  });
  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (250 + headerHeight));
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [height]);
  return (
    <>
      <Box className="flex-none" mx="10px" style={{ position: "relative" }}>
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 2 }}
        />
        <Flex justify={"space-between"} align={"center"} mt={10}>
          <CopyButton value={String(dataItemBase?.itemName)} timeout={2000}>
            {({ copied, copy }) => (
              <Tooltip
                label={copied ? "Đã sao chép" : "Sao chép"}
                withArrow
                position="right"
              >
                <Badge
                  color={copied ? "teal" : "blue"}
                  onClick={copy}
                  style={{ cursor: "pointer" }}
                  size="lg"
                >
                  {dataItemBase?.itemName}
                </Badge>
              </Tooltip>
            )}
          </CopyButton>
        </Flex>
        <Grid justify="space-between" align="center" mb={10}>
          <Grid.Col span="auto">
            <Group gap="sm" mt={12}>
              <TextInput
                placeholder="Nhập tìm kiếm"
                key={form.key("keySearch")}
                leftSection={<IconSearch size={20} color="#15aabf" />}
                onKeyDown={async (e) => {
                  if (e.key === "Enter") {
                    await fetchDataComboSet();
                  }
                }}
                {...form.getInputProps("keySearch")}
                w={200}
              />
              <Select
                placeholder="Chọn trạng thái"
                data={[
                  { value: "true", label: "Đã chọn" },
                  { value: "false", label: "Chưa chọn" },
                ]}
                clearable
                {...form.getInputProps("isSelect")}
              />
              <Button
                color="blue"
                variant="outline"
                onClick={async () => {
                  await fetchDataComboSet();
                }}
              >
                Tìm kiếm
              </Button>
            </Group>
          </Grid.Col>
          <Grid.Col span="content">
            <Group justify="flex-end" mt={10}>
              <OpenProductTab
                productId={dataItemBase?.id}
                itemCode={dataItemBase?.itemName ?? ""}
                tabToOpen="info8"
                buttonText="Mở trang tab"
              />
              <Button
                color="red"
                onClick={() => {
                  navigate(-1);
                }}
                leftSection={<IconX size={18} />}
              >
                Đóng
              </Button>
            </Group>
          </Grid.Col>
        </Grid>

        <MantineReactTable table={table} />
      </Box>
    </>
  );
};

export default ItemComboSet;
